import { render, staticRenderFns } from "./WheelsetBearing.vue?vue&type=template&id=3f668ce8&scoped=true"
import script from "./WheelsetBearing.vue?vue&type=script&lang=js"
export * from "./WheelsetBearing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f668ce8",
  null
  
)

export default component.exports